/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProcedureWraper } from "../..";
import { MyRequests } from "./components";
import { MajorTableList } from "./components/TableList";

const SummaryRegistrationCourses = withProcedureWraper(() => {
  return (
    <div className="pd15">
      <div className="text-md-left font-weight-normal p-3 bg-info text-white" style={{ fontSize: "14px" }}>
        <div className="row title__process-container">
          <div className="">Bảng tổng hợp nhân sự tham gia khóa học </div>
          <div className="See-User-Manual">
            <a href="#" target="_blank" rel="noreferrer" className="See-User-Manual ml-1">
              Xem hướng dẫn sử dụng
            </a>
          </div>
        </div>
      </div>

      <MyRequests />
      <MajorTableList />
    </div>
  );
});

export default SummaryRegistrationCourses;
